import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import './FAQ.css';

const FAQ = ({ faqs = [], heading, image, imagePosition = 'right' }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <Container fluid className="faq-container-fluid">
      <div className="faq-content-container">

        {image && imagePosition === 'left' && (
          <div className="faq-right-section">
            <img src={image} alt="FAQ visual" />
          </div>
        )}

        <div className="faq-left-section fq-section-padding">
          {heading && (
            <p className="faq-heading page_heading">{heading}</p>
          )}

          <div className="faq-items-wrapper">
            {faqs.map((faq, index) => (
              <div className="faq-item" key={index}>
                <button
                  type="button"
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                  aria-expanded={activeIndex === index}
                >
                  <h5 className="page_text question">
                    {faq.question}
                  </h5>

                  <span className="faq-icon">
                    {activeIndex === index ? '⌃' : '⌄'}
                  </span>
                </button>

                <div
                  className={`faq-answer-wrapper ${
                    activeIndex === index ? 'open' : ''
                  }`}
                >
                  <p className="faq-answer">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {image && imagePosition === 'right' && (
          <div className="faq-right-section">
            <img src={image} alt="FAQ visual" />
          </div>
        )}

      </div>
    </Container>
  );
};

export default FAQ;